module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-forward-circle-fill-80677af6.svg";